// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Par Seeker Theme System */

/* ============================================
   GLOBAL OVERFLOW FIX - Prevent horizontal scroll
   ============================================ */
html, body {
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

#root {
  overflow-x: hidden;
  max-width: 100vw;
  width: 100%;
}

/* ============================================
   DEFAULT (Dark Theme) - Applied by default
   ============================================ */
:root,
.theme-dark {
  /* Primary Colors - Golf Green */
  --ps-primary: #22c55e;
  --ps-primary-hover: #16a34a;
  --ps-primary-dark: #15803d;
  --ps-primary-light: rgba(34, 197, 94, 0.1);
  --ps-primary-glow: rgba(34, 197, 94, 0.3);
  
  /* Online Status Glow */
  --ps-online-glow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4);
  
  /* Accent Colors - Logo Gold */
  --ps-gold: #D4A017;
  --ps-gold-light: #F5C542;
  --ps-gold-dark: #B8860B;
  
  /* Background Colors - Dark */
  --ps-bg-base: #0A0A0A;
  --ps-bg-surface: #171717;
  --ps-bg-elevated: #1f1f1f;
  --ps-bg-hover: #262626;
  
  /* Border Colors */
  --ps-border: #262626;
  --ps-border-light: #333333;
  
  /* Text Colors */
  --ps-text-primary: #FFFFFF;
  --ps-text-secondary: #A3A3A3;
  --ps-text-muted: #737373;
  --ps-text-accent: #22c55e;
  
  /* Semantic Colors */
  --ps-success: #22c55e;
  --ps-warning: #f59e0b;
  --ps-error: #ef4444;
  --ps-info: #3b82f6;
  
  /* Glass/Overlay */
  --ps-glass-bg: rgba(10, 10, 10, 0.85);
  --ps-overlay: rgba(0, 0, 0, 0.6);
  
  /* 3D Inset Shadow Effect */
  --ps-inset-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), inset 0 1px 2px rgba(0, 0, 0, 0.3);
  --ps-inset-glow: 0 1px 0 rgba(255, 255, 255, 0.05);
  --ps-field-border: rgba(255, 255, 255, 0.08);
}

/* ============================================
   LIGHT THEME - Golf Course Inspired
   Based on natural golf course colors:
   - Fresh green fairways
   - Cream/tan bunker sand  
   - Bright sky blues
   ============================================ */
.theme-light {
  /* Primary Colors - Golf Green (slightly darker for contrast) */
  --ps-primary: #16a34a;
  --ps-primary-hover: #15803d;
  --ps-primary-dark: #166534;
  --ps-primary-light: rgba(22, 163, 74, 0.12);
  --ps-primary-glow: rgba(22, 163, 74, 0.25);
  
  /* Accent Colors - Logo Gold (darker for light bg contrast) */
  --ps-gold: #B8860B;
  --ps-gold-light: #D4A017;
  --ps-gold-dark: #8B6914;
  
  /* Background Colors - Light/Natural */
  --ps-bg-base: #F5F5F0;           /* Warm off-white like fairway mist */
  --ps-bg-surface: #FFFFFF;         /* Pure white cards */
  --ps-bg-elevated: #FAFAF5;        /* Slightly elevated surfaces */
  --ps-bg-hover: #EEEEEA;           /* Hover state */
  
  /* Border Colors */
  --ps-border: #E5E5E0;             /* Soft borders */
  --ps-border-light: #D4D4D0;       /* Stronger borders */
  
  /* Text Colors */
  --ps-text-primary: #1A1A1A;       /* Near black */
  --ps-text-secondary: #525252;     /* Medium gray */
  --ps-text-muted: #737373;         /* Light gray */
  --ps-text-accent: #16a34a;        /* Green accent */
  
  /* Semantic Colors (slightly adjusted for light bg) */
  --ps-success: #16a34a;
  --ps-warning: #d97706;
  --ps-error: #dc2626;
  --ps-info: #2563eb;
  
  /* Glass/Overlay */
  --ps-glass-bg: rgba(255, 255, 255, 0.9);
  --ps-overlay: rgba(0, 0, 0, 0.4);
}

/* ============================================
   FONT SIZE SCALING
   ============================================ */

/* Small (Default/Current) */
.font-small {
  --ps-font-scale: 1;
  --ps-spacing-scale: 1;
}

/* Medium */
.font-medium {
  --ps-font-scale: 1.1;
  --ps-spacing-scale: 1.05;
}

/* Large */
.font-large {
  --ps-font-scale: 1.2;
  --ps-spacing-scale: 1.1;
}

/* Apply font scaling to body text */
.font-medium body,
.font-medium .dark-app {
  font-size: calc(1rem * 1.1);
}

.font-large body,
.font-large .dark-app {
  font-size: calc(1rem * 1.2);
}

/* Scale headings */
.font-medium h1 { font-size: calc(1.875rem * 1.1); }
.font-medium h2 { font-size: calc(1.5rem * 1.1); }
.font-medium h3 { font-size: calc(1.25rem * 1.1); }

.font-large h1 { font-size: calc(1.875rem * 1.2); }
.font-large h2 { font-size: calc(1.5rem * 1.2); }
.font-large h3 { font-size: calc(1.25rem * 1.2); }

/* Scale feed post text */
.font-medium .feed-post-content p { font-size: calc(0.9375rem * 1.1); }
.font-large .feed-post-content p { font-size: calc(0.9375rem * 1.2); }

.font-medium .feed-post-name { font-size: calc(0.9375rem * 1.1); }
.font-large .feed-post-name { font-size: calc(0.9375rem * 1.2); }

/* Scale input text */
.font-medium input,
.font-medium textarea,
.font-medium select {
  font-size: calc(1rem * 1.1);
}

.font-large input,
.font-large textarea,
.font-large select {
  font-size: calc(1rem * 1.2);
}

/* Scale button text */
.font-medium button { font-size: calc(0.875rem * 1.1); }
.font-large button { font-size: calc(0.875rem * 1.2); }

/* Scale card content */
.font-medium .dark-card p,
.font-medium .dark-card span:not(.text-xs) {
  font-size: calc(0.875rem * 1.1);
}

.font-large .dark-card p,
.font-large .dark-card span:not(.text-xs) {
  font-size: calc(0.875rem * 1.2);
}

/* Keep navigation labels small */
.font-medium .bottom-nav-item,
.font-large .bottom-nav-item,
.font-medium .top-nav-item,
.font-large .top-nav-item {
  font-size: 0.65rem;
}

/* ============================================
   LIGHT THEME SPECIFIC OVERRIDES
   ============================================ */

/* Glass navigation for light theme */
.theme-light .glass-nav {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

/* Card shadows for light theme */
.theme-light .dark-card,
.theme-light .feed-post {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
}

.theme-light .dark-card:hover,
.theme-light .feed-post:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
}

/* Create button adjustment for light theme */
.theme-light .create-btn {
  box-shadow: 0 4px 14px rgba(22, 163, 74, 0.35);
  color: white;
}

/* Input styling for light theme */
.theme-light input,
.theme-light textarea,
.theme-light select {
  background-color: var(--ps-bg-surface);
  color: var(--ps-text-primary);
}

.theme-light input::placeholder,
.theme-light textarea::placeholder {
  color: var(--ps-text-muted);
}

/* Avatar fallback for light theme */
.theme-light .bg-\\[var\\(--ps-bg-elevated\\)\\] {
  background-color: var(--ps-bg-elevated);
}

/* Dialog/Modal for light theme */
.theme-light [role="dialog"] {
  background-color: var(--ps-bg-surface);
}

/* Spinner for light theme */
.theme-light .dark-spinner {
  border-color: var(--ps-border);
  border-top-color: var(--ps-primary);
}

/* Bottom navigation for light theme */
.theme-light .bottom-nav {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

/* Top navigation icons for light theme */
.theme-light .top-nav-item {
  color: var(--ps-text-secondary);
}

.theme-light .top-nav-item.active {
  color: var(--ps-primary);
}

.theme-light .top-nav-item:hover {
  color: var(--ps-text-primary);
}

/* Glass header for light theme */
.theme-light .glass-nav,
.theme-light .dark-header {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
}

/* Feed tabs for light theme */
.theme-light .feed-tab {
  color: var(--ps-text-secondary);
}

.theme-light .feed-tab.active {
  color: var(--ps-primary);
}

/* Story avatar wrapper for light theme */
.theme-light .story-avatar-wrapper {
  background: linear-gradient(45deg, var(--ps-primary), #059669);
}

.theme-light .story-avatar-wrapper.no-story {
  background: var(--ps-border);
}

/* Stats widget for light theme */
.theme-light .compact-stats-widget {
  background-color: var(--ps-bg-surface);
}

/* Post header options button */
.theme-light .feed-post-header button {
  color: var(--ps-text-secondary);
}

.theme-light .feed-post-header button:hover {
  color: var(--ps-text-primary);
}

/* Buttons with bg-elevated */
.theme-light .bg-\\[var\\(--ps-bg-elevated\\)\\] {
  background-color: var(--ps-bg-elevated);
}

/* Fix white text that should be dark in light mode */
.theme-light .text-white {
  color: var(--ps-text-primary);
}

/* But keep white text on colored backgrounds */
.theme-light .bg-\\[var\\(--ps-primary\\)\\] .text-white,
.theme-light .bg-gradient-to-br .text-white,
.theme-light .create-btn,
.theme-light [class*="bg-green"] .text-white,
.theme-light [class*="bg-blue"] .text-white,
.theme-light [class*="bg-red"] .text-white {
  color: white !important;
}

/* ============================================
   DARK THEME (Existing Styles Below)
   ============================================ */

/* ============================================
   3D INSET SHADOW - Input Fields & Borders
   Creates depth effect on all interactive fields
   ============================================ */

/* Global input, textarea, select styling with 3D inset effect */
input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
textarea,
select,
.ps-input,
.ps-field {
  background: linear-gradient(180deg, 
    rgba(0, 0, 0, 0.15) 0%, 
    rgba(20, 20, 20, 0.05) 15%,
    rgba(30, 30, 30, 0) 100%
  ), var(--ps-bg-elevated);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-top-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-shadow: 
    inset 0 3px 8px rgba(0, 0, 0, 0.5),
    inset 0 1px 3px rgba(0, 0, 0, 0.4),
    inset 0 -1px 0 rgba(255, 255, 255, 0.05),
    0 1px 0 rgba(255, 255, 255, 0.03);
  transition: all 0.2s ease;
}

input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):focus,
textarea:focus,
select:focus,
.ps-input:focus,
.ps-field:focus {
  outline: none;
  border-color: var(--ps-primary);
  box-shadow: 
    inset 0 3px 8px rgba(0, 0, 0, 0.5),
    inset 0 1px 3px rgba(0, 0, 0, 0.4),
    inset 0 -1px 0 rgba(255, 255, 255, 0.05),
    0 0 0 3px rgba(34, 197, 94, 0.2),
    0 1px 0 rgba(255, 255, 255, 0.03);
}

/* Cards and containers with subtle depth */
.ps-card,
.dark-card,
.dark-stat-card {
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.03) 0%,
    rgba(255, 255, 255, 0) 100%
  ), var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-top-color: rgba(255, 255, 255, 0.08);
  box-shadow: 
    0 4px 12px rgba(0, 0, 0, 0.4),
    0 2px 4px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);
  border-radius: 12px;
}

/* Inset containers (like the message box in the screenshot) */
.ps-inset,
.inset-field {
  background: linear-gradient(180deg,
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.05) 20%,
    rgba(30, 30, 30, 0) 100%
  ), var(--ps-bg-elevated);
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-top-color: rgba(0, 0, 0, 0.4);
  border-bottom-color: rgba(255, 255, 255, 0.06);
  border-radius: 12px;
  box-shadow: 
    inset 0 4px 10px rgba(0, 0, 0, 0.5),
    inset 0 2px 4px rgba(0, 0, 0, 0.4),
    inset 0 -1px 0 rgba(255, 255, 255, 0.04),
    0 1px 0 rgba(255, 255, 255, 0.02);
}

/* Light theme adjustments for 3D effect */
.theme-light input:not([type="checkbox"]):not([type="radio"]):not([type="range"]),
.theme-light textarea,
.theme-light select,
.theme-light .ps-input,
.theme-light .ps-field {
  background: linear-gradient(180deg,
    rgba(0, 0, 0, 0.04) 0%,
    rgba(0, 0, 0, 0.01) 15%,
    rgba(255, 255, 255, 0) 100%
  ), var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-top-color: rgba(0, 0, 0, 0.12);
  box-shadow: 
    inset 0 2px 6px rgba(0, 0, 0, 0.08),
    inset 0 1px 3px rgba(0, 0, 0, 0.06),
    inset 0 -1px 0 rgba(255, 255, 255, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.8);
}

.theme-light input:not([type="checkbox"]):not([type="radio"]):not([type="range"]):focus,
.theme-light textarea:focus,
.theme-light select:focus {
  border-color: var(--ps-primary);
  box-shadow: 
    inset 0 2px 6px rgba(0, 0, 0, 0.08),
    inset 0 1px 3px rgba(0, 0, 0, 0.06),
    inset 0 -1px 0 rgba(255, 255, 255, 0.9),
    0 0 0 3px rgba(22, 163, 74, 0.15),
    0 1px 0 rgba(255, 255, 255, 0.8);
}

.theme-light .ps-card,
.theme-light .dark-card,
.theme-light .dark-stat-card {
  background: linear-gradient(180deg,
    rgba(255, 255, 255, 0.8) 0%,
    rgba(255, 255, 255, 0) 100%
  ), var(--ps-bg-surface);
  border-top-color: rgba(255, 255, 255, 0.9);
  box-shadow: 
    0 2px 8px rgba(0, 0, 0, 0.08),
    0 1px 3px rgba(0, 0, 0, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.theme-light .ps-inset,
.theme-light .inset-field {
  background: linear-gradient(180deg,
    rgba(0, 0, 0, 0.05) 0%,
    rgba(0, 0, 0, 0.02) 20%,
    rgba(255, 255, 255, 0) 100%
  ), var(--ps-bg-elevated);
  border: 1px solid var(--ps-border);
  border-top-color: rgba(0, 0, 0, 0.1);
  box-shadow: 
    inset 0 3px 8px rgba(0, 0, 0, 0.1),
    inset 0 1px 4px rgba(0, 0, 0, 0.08),
    inset 0 -1px 0 rgba(255, 255, 255, 0.9),
    0 1px 0 rgba(255, 255, 255, 0.9);
}

/* Dark Theme App Container */
.dark-app {
  background-color: var(--ps-bg-base);
  color: var(--ps-text-primary);
  min-height: 100vh;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Glassmorphism Navigation */
.glass-nav {
  background: rgba(10, 10, 10, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-color: var(--ps-border);
}

/* Top Navigation */
.top-nav {
  position: sticky;
  top: 0;
  z-index: 50;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--ps-border);
}

.top-nav-inner {
  max-width: 640px;
  margin: 0 auto;
}

.top-nav-icons {
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 0.5rem;
}

.top-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  color: var(--ps-text-secondary);
  font-size: 0.65rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: color 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
}

.top-nav-item:hover {
  color: var(--ps-text-primary);
  background-color: var(--ps-bg-hover);
}

.top-nav-item.active {
  color: var(--ps-primary);
}

.top-nav-item.active svg {
  filter: drop-shadow(0 0 8px var(--ps-primary-glow));
}

/* Bottom Navigation */
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 50;
  padding: 0;
  padding-bottom: env(safe-area-inset-bottom);
  border-top: none;
  background-color: var(--ps-bg-surface);
}

/* Ticker wrapper inside bottom nav */
.ticker-wrapper {
  width: 100%;
  border-top: 1px solid var(--ps-border);
}

.bottom-nav-inner {
  max-width: 640px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.5rem 1rem;
}

.bottom-nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem 1rem;
  border-radius: 0.75rem;
  color: var(--ps-text-secondary);
  font-size: 0.65rem;
  font-weight: 500;
  transition: color 0.2s ease, transform 0.2s ease;
  cursor: pointer;
}

.bottom-nav-item:hover {
  color: var(--ps-text-primary);
}

.bottom-nav-item.active {
  color: var(--ps-primary);
}

.bottom-nav-item:active {
  transform: scale(0.95);
}

/* Center Create Button */
.create-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: var(--ps-primary);
  color: var(--ps-bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -1.5rem;
  box-shadow: 0 4px 20px var(--ps-primary-glow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
}

.create-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 25px var(--ps-primary-glow);
}

.create-btn:active {
  transform: scale(0.95);
}

/* Quick Post Button - Glowing Blue Plus in Bottom Nav */
.quick-post-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.quick-post-btn-inner {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #00bfff 0%, #0080ff 50%, #00bfff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 
    0 0 15px rgba(0, 191, 255, 0.6),
    0 0 30px rgba(0, 191, 255, 0.4),
    0 0 45px rgba(0, 191, 255, 0.2),
    inset 0 0 10px rgba(255, 255, 255, 0.3);
  animation: pulse-glow 2s ease-in-out infinite;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 
      0 0 15px rgba(0, 191, 255, 0.6),
      0 0 30px rgba(0, 191, 255, 0.4),
      0 0 45px rgba(0, 191, 255, 0.2),
      inset 0 0 10px rgba(255, 255, 255, 0.3);
  }
  50% {
    box-shadow: 
      0 0 20px rgba(0, 191, 255, 0.8),
      0 0 40px rgba(0, 191, 255, 0.5),
      0 0 60px rgba(0, 191, 255, 0.3),
      inset 0 0 15px rgba(255, 255, 255, 0.4);
  }
}

.quick-post-btn:hover .quick-post-btn-inner {
  transform: scale(1.1);
  box-shadow: 
    0 0 25px rgba(0, 191, 255, 0.8),
    0 0 50px rgba(0, 191, 255, 0.5),
    0 0 75px rgba(0, 191, 255, 0.3),
    inset 0 0 15px rgba(255, 255, 255, 0.4);
}

.quick-post-btn:active .quick-post-btn-inner {
  transform: scale(0.95);
}

/* Dark Theme Cards */
.dark-card {
  background-color: var(--ps-bg-surface) !important;
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
}

.dark-card:hover {
  border-color: var(--ps-border-light);
}

/* Feed Post Card */
.feed-post {
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  overflow: hidden;
  transition: border-color 0.2s ease;
}

.feed-post:hover {
  border-color: var(--ps-border-light);
}

.feed-post-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem;
}

.feed-post-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.feed-post-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--ps-border);
}

.feed-post-meta {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
}

.feed-post-name {
  font-weight: 600;
  color: var(--ps-text-primary);
  font-size: 0.9375rem;
}

.feed-post-details {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.75rem;
  color: var(--ps-text-muted);
}

.handicap-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  background-color: var(--ps-primary-light);
  color: var(--ps-primary);
  font-size: 0.6875rem;
  font-weight: 600;
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.category-badge {
  color: var(--ps-primary);
  font-weight: 500;
}

.feed-post-content {
  padding: 0 1rem 1rem;
  color: var(--ps-text-primary);
  font-size: 0.9375rem;
  line-height: 1.5;
}

.feed-post-image {
  width: 100%;
  max-height: 500px;
  object-fit: cover;
}

.feed-post-reactions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem;
  border-top: 1px solid var(--ps-border);
  font-size: 0.8125rem;
  color: var(--ps-text-secondary);
}

.reaction-avatars {
  display: flex;
  align-items: center;
}

.reaction-avatars img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--ps-bg-surface);
  margin-left: -8px;
}

.reaction-avatars img:first-child {
  margin-left: 0;
}

.feed-post-actions {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0.5rem 1rem;
  border-top: 1px solid var(--ps-border);
}

.post-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
  color: var(--ps-text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
  transition: color 0.2s ease, background-color 0.2s ease;
  cursor: pointer;
}

.post-action-btn:hover {
  color: var(--ps-text-primary);
  background-color: var(--ps-bg-hover);
}

.post-action-btn.liked {
  color: var(--ps-error);
}

.post-action-btn.liked svg {
  fill: currentColor;
}

/* Stories Row */
.stories-container {
  display: flex;
  gap: 1rem;
  padding: 1rem;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.stories-container::-webkit-scrollbar {
  display: none;
}

.story-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  cursor: pointer;
}

.story-avatar-wrapper {
  position: relative;
  padding: 3px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--ps-primary) 0%, #10b981 100%);
}

.story-avatar-wrapper.no-story {
  background: var(--ps-border);
}

.story-avatar-wrapper.create {
  background: var(--ps-bg-surface);
  border: 2px dashed var(--ps-border);
}

.story-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  object-fit: cover;
  background-color: var(--ps-bg-surface);
  border: 3px solid var(--ps-bg-base);
}

.story-create-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--ps-primary);
  color: var(--ps-bg-base);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--ps-bg-base);
}

.story-name {
  font-size: 0.6875rem;
  color: var(--ps-text-secondary);
  max-width: 70px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Feed Filter Tabs */
.feed-tabs {
  display: flex;
  gap: 1.5rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid var(--ps-border);
  overflow-x: auto;
  scrollbar-width: none;
}

.feed-tabs::-webkit-scrollbar {
  display: none;
}

.feed-tab {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ps-text-secondary);
  padding-bottom: 0.5rem;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
}

.feed-tab:hover {
  color: var(--ps-text-primary);
}

.feed-tab.active {
  color: var(--ps-text-primary);
  border-bottom-color: var(--ps-primary);
}

/* Main Content Area */
.dark-main-content {
  max-width: 640px;
  margin: 0 auto;
  padding-bottom: calc(7rem + env(safe-area-inset-bottom)); /* Space for ticker + nav */
}

/* Full Screen Main Content - No navigation padding */
.dark-main-content-fullscreen {
  max-width: 100%;
  margin: 0;
  padding-top: 0;
  padding-bottom: env(safe-area-inset-bottom);
  min-height: 100vh;
  min-height: 100dvh;
}

/* Dark Theme Inputs */
.dark-input {
  background-color: var(--ps-bg-elevated) !important;
  border: 1px solid var(--ps-border) !important;
  color: var(--ps-text-primary) !important;
  border-radius: 0.75rem;
  padding: 0.75rem 1rem;
  font-size: 0.9375rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.dark-input:focus {
  outline: none;
  border-color: var(--ps-primary) !important;
  box-shadow: 0 0 0 3px var(--ps-primary-light);
}

.dark-input::placeholder {
  color: var(--ps-text-muted) !important;
}

/* Dark Theme Buttons */
.dark-btn-primary {
  background-color: var(--ps-primary);
  color: var(--ps-bg-base);
  font-weight: 600;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.dark-btn-primary:hover {
  background-color: var(--ps-primary-hover);
}

.dark-btn-primary:active {
  transform: scale(0.98);
}

.dark-btn-secondary {
  background-color: var(--ps-bg-hover);
  color: var(--ps-text-primary);
  font-weight: 500;
  padding: 0.75rem 1.5rem;
  border-radius: 9999px;
  border: 1px solid var(--ps-border);
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.dark-btn-secondary:hover {
  background-color: var(--ps-bg-elevated);
  border-color: var(--ps-border-light);
}

/* Notification Badge */
.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  border-radius: 9999px;
  background-color: var(--ps-error);
  color: white;
  font-size: 0.625rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

/* Loading Spinner (Dark) */
.dark-spinner {
  width: 2rem;
  height: 2rem;
  border: 3px solid var(--ps-border);
  border-top-color: var(--ps-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* Empty State */
.dark-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: var(--ps-text-secondary);
}

.dark-empty-state svg {
  width: 4rem;
  height: 4rem;
  margin-bottom: 1.5rem;
  color: var(--ps-text-muted);
}

/* Story Viewer Modal */
.story-viewer {
  position: fixed;
  inset: 0;
  z-index: 100;
  background-color: var(--ps-bg-base);
  display: flex;
  flex-direction: column;
}

.story-viewer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.story-progress-container {
  display: flex;
  gap: 4px;
  padding: 0.5rem 1rem;
}

.story-progress-bar {
  flex: 1 1;
  height: 3px;
  background-color: var(--ps-border);
  border-radius: 2px;
  overflow: hidden;
}

.story-progress-fill {
  height: 100%;
  background-color: var(--ps-text-primary);
  transition: width 0.1s linear;
}

.story-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.story-content img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 0.5rem;
}

/* Responsive Desktop Layout */
@media (min-width: 768px) {
  .dark-main-content {
    padding-top: 1rem;
  }
  
  .top-nav {
    position: sticky;
  }
  
  .bottom-nav {
    display: none;
  }
  
  /* Show desktop sidebar instead */
  .dark-app.with-sidebar {
    display: grid;
    grid-template-columns: 280px 1fr;
  }
  
  .dark-sidebar {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    width: 280px;
    background-color: var(--ps-bg-surface);
    border-right: 1px solid var(--ps-border);
    padding: 1.5rem;
    z-index: 40;
  }
  
  .dark-main-with-sidebar {
    margin-left: 280px;
  }
}

/* Animation keyframes */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in {
  animation: fadeIn 0.3s ease forwards;
}

/* More Menu Dropdown */
.more-menu {
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.5rem;
  min-width: 200px;
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.more-menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.875rem 1rem;
  color: var(--ps-text-primary);
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.more-menu-item:hover {
  background-color: var(--ps-bg-hover);
}

.more-menu-item svg {
  width: 1.125rem;
  height: 1.125rem;
  color: var(--ps-text-secondary);
}

.more-menu-divider {
  height: 1px;
  background-color: var(--ps-border);
  margin: 0.25rem 0;
}

/* ========== DARK PAGE STYLES ========== */

/* Page Container */
.dark-page {
  min-height: 100%;
  padding-bottom: 5rem;
}

/* Page Header */
.dark-page-header {
  padding: 1rem;
  border-bottom: 1px solid var(--ps-border);
}

.dark-page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--ps-text-primary);
}

.dark-page-subtitle {
  font-size: 0.875rem;
  color: var(--ps-text-muted);
  margin-top: 0.25rem;
}

/* Section Headers */
.dark-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.dark-section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--ps-text-primary);
}

/* Stats Cards */
.dark-stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

@media (min-width: 640px) {
  .dark-stats-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

.dark-stat-card {
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  padding: 1rem;
  text-align: center;
  transition: border-color 0.2s ease;
}

.dark-stat-card:hover {
  border-color: var(--ps-border-light);
}

.dark-stat-icon {
  width: 2.5rem;
  height: 2.5rem;
  margin: 0 auto 0.75rem;
  padding: 0.5rem;
  background-color: var(--ps-primary-light);
  border-radius: 0.75rem;
  color: var(--ps-primary);
}

.dark-stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--ps-text-primary);
  line-height: 1.2;
}

.dark-stat-label {
  font-size: 0.75rem;
  color: var(--ps-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 0.25rem;
}

.dark-stat-change {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  margin-top: 0.5rem;
}

.dark-stat-change.positive {
  color: var(--ps-success);
}

.dark-stat-change.negative {
  color: var(--ps-error);
}

/* List Items */
.dark-list {
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  overflow: hidden;
}

.dark-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid var(--ps-border);
  transition: background-color 0.15s ease;
  cursor: pointer;
}

.dark-list-item:last-child {
  border-bottom: none;
}

.dark-list-item:hover {
  background-color: var(--ps-bg-hover);
}

.dark-list-item-content {
  flex: 1 1;
  min-width: 0;
}

.dark-list-item-title {
  font-weight: 600;
  color: var(--ps-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark-list-item-subtitle {
  font-size: 0.875rem;
  color: var(--ps-text-muted);
  margin-top: 0.125rem;
}

.dark-list-item-meta {
  text-align: right;
  color: var(--ps-text-secondary);
  font-size: 0.875rem;
}

/* Quick Action Buttons */
.dark-quick-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
}

@media (min-width: 640px) {
  .dark-quick-actions {
    grid-template-columns: repeat(4, 1fr);
  }
}

.dark-action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.25rem 1rem;
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  color: var(--ps-text-secondary);
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.2s ease;
  cursor: pointer;
}

.dark-action-btn:hover {
  border-color: var(--ps-primary);
  color: var(--ps-primary);
  background-color: var(--ps-primary-light);
}

.dark-action-btn svg {
  width: 1.5rem;
  height: 1.5rem;
}

.dark-action-btn.primary {
  background-color: var(--ps-primary);
  border-color: var(--ps-primary);
  color: var(--ps-bg-base);
}

.dark-action-btn.primary:hover {
  background-color: var(--ps-primary-hover);
  border-color: var(--ps-primary-hover);
  color: var(--ps-bg-base);
}

/* Form Sections */
.dark-form-section {
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  padding: 1.25rem;
  margin-bottom: 1rem;
}

.dark-form-section-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ps-text-primary);
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dark-form-section-title svg {
  width: 1.125rem;
  height: 1.125rem;
  color: var(--ps-primary);
}

.dark-form-row {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.dark-form-row:last-child {
  margin-bottom: 0;
}

/* Toggle Switches */
.dark-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 0.75rem;
}

.dark-toggle-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.dark-toggle-label svg {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--ps-primary);
}

.dark-toggle-text {
  font-weight: 500;
  color: var(--ps-text-primary);
}

.dark-toggle-desc {
  font-size: 0.75rem;
  color: var(--ps-text-muted);
  margin-top: 0.125rem;
}

/* Badge/Tags */
.dark-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.625rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
}

.dark-badge.primary {
  background-color: var(--ps-primary-light);
  color: var(--ps-primary);
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.dark-badge.success {
  background-color: rgba(34, 197, 94, 0.1);
  color: var(--ps-success);
}

.dark-badge.warning {
  background-color: rgba(245, 158, 11, 0.1);
  color: var(--ps-warning);
}

.dark-badge.error {
  background-color: rgba(239, 68, 68, 0.1);
  color: var(--ps-error);
}

.dark-badge.info {
  background-color: rgba(59, 130, 246, 0.1);
  color: var(--ps-info);
}

.dark-badge.muted {
  background-color: var(--ps-bg-hover);
  color: var(--ps-text-muted);
}

/* Charts Container */
.dark-chart-container {
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
  padding: 1rem;
}

/* Score Circle */
.dark-score-circle {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--ps-bg-elevated);
  border: 2px solid var(--ps-border);
}

.dark-score-circle.good {
  border-color: var(--ps-success);
  background-color: rgba(34, 197, 94, 0.1);
}

.dark-score-circle.bad {
  border-color: var(--ps-error);
  background-color: rgba(239, 68, 68, 0.1);
}

.dark-score-circle-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--ps-text-primary);
  line-height: 1;
}

.dark-score-circle-label {
  font-size: 0.625rem;
  color: var(--ps-text-muted);
  text-transform: uppercase;
}

/* Tabs */
.dark-tabs {
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
  background-color: var(--ps-bg-surface);
  border-radius: 0.75rem;
  border: 1px solid var(--ps-border);
}

.dark-tab {
  flex: 1 1;
  padding: 0.625rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--ps-text-secondary);
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dark-tab:hover {
  color: var(--ps-text-primary);
}

.dark-tab.active {
  background-color: var(--ps-primary);
  color: var(--ps-bg-base);
}

/* Select Dropdown Dark Override */
.dark-select [data-radix-select-trigger] {
  background-color: var(--ps-bg-surface) !important;
  border-color: var(--ps-border) !important;
  color: var(--ps-text-primary) !important;
}

.dark-select [data-radix-select-content] {
  background-color: var(--ps-bg-surface) !important;
  border-color: var(--ps-border) !important;
}

.dark-select [data-radix-select-item] {
  color: var(--ps-text-primary) !important;
}

.dark-select [data-radix-select-item]:hover,
.dark-select [data-radix-select-item][data-highlighted] {
  background-color: var(--ps-bg-hover) !important;
}

/* Table Styles */
.dark-table {
  width: 100%;
  border-collapse: collapse;
}

.dark-table th {
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ps-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--ps-border);
  background-color: var(--ps-bg-surface);
}

.dark-table td {
  padding: 0.875rem 1rem;
  font-size: 0.875rem;
  color: var(--ps-text-primary);
  border-bottom: 1px solid var(--ps-border);
}

.dark-table tr:hover td {
  background-color: var(--ps-bg-hover);
}

.dark-table tr:last-child td {
  border-bottom: none;
}

/* Scorecard Grid */
.dark-scorecard {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  gap: 2px;
  background-color: var(--ps-border);
  border-radius: 0.75rem;
  overflow: hidden;
}

.dark-scorecard-cell {
  background-color: var(--ps-bg-surface);
  padding: 0.5rem;
  text-align: center;
  font-size: 0.875rem;
}

.dark-scorecard-cell.header {
  background-color: var(--ps-bg-elevated);
  font-weight: 600;
  color: var(--ps-text-muted);
  font-size: 0.75rem;
}

.dark-scorecard-cell.birdie {
  color: var(--ps-success);
  font-weight: 600;
}

.dark-scorecard-cell.bogey {
  color: var(--ps-warning);
}

.dark-scorecard-cell.double {
  color: var(--ps-error);
}

/* Handicap Display */
.dark-handicap-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, var(--ps-bg-surface) 0%, var(--ps-bg-elevated) 100%);
  border: 1px solid var(--ps-border);
  border-radius: 1rem;
}

.dark-handicap-value {
  font-size: 3rem;
  font-weight: 800;
  color: var(--ps-primary);
  line-height: 1;
}

.dark-handicap-label {
  font-size: 0.875rem;
  color: var(--ps-text-muted);
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-top: 0.5rem;
}

/* Divider */
.dark-divider {
  height: 1px;
  background-color: var(--ps-border);
  margin: 1.5rem 0;
}

/* Info Box */
.dark-info-box {
  display: flex;
  gap: 0.75rem;
  padding: 1rem;
  background-color: var(--ps-bg-surface);
  border: 1px solid var(--ps-border);
  border-radius: 0.75rem;
}

.dark-info-box.info {
  border-color: var(--ps-info);
  background-color: rgba(59, 130, 246, 0.05);
}

.dark-info-box.warning {
  border-color: var(--ps-warning);
  background-color: rgba(245, 158, 11, 0.05);
}

.dark-info-box.success {
  border-color: var(--ps-success);
  background-color: rgba(34, 197, 94, 0.05);
}

.dark-info-box svg {
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
}

.dark-info-box.info svg {
  color: var(--ps-info);
}

.dark-info-box.warning svg {
  color: var(--ps-warning);
}

.dark-info-box.success svg {
  color: var(--ps-success);
}

.dark-info-box-text {
  font-size: 0.875rem;
  color: var(--ps-text-secondary);
}

/* Avatar Styles */
.dark-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: var(--ps-bg-elevated);
  border: 2px solid var(--ps-border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ps-primary);
  font-weight: 600;
  overflow: hidden;
}

.dark-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dark-avatar.lg {
  width: 4rem;
  height: 4rem;
  font-size: 1.5rem;
}

.dark-avatar.xl {
  width: 6rem;
  height: 6rem;
  font-size: 2rem;
}

/* Dropdown/Popover Dark Override */
[data-radix-popper-content-wrapper] {
  z-index: 100 !important;
}

.dark-app [role="dialog"],
.dark-app [data-radix-select-content],
.dark-app [data-radix-dropdown-menu-content],
.dark-app [data-radix-popover-content] {
  background-color: var(--ps-bg-surface) !important;
  border-color: var(--ps-border) !important;
  color: var(--ps-text-primary) !important;
}

/* Calendar Dark Override */
.dark-app .rdp {
  --rdp-accent-color: var(--ps-primary) !important;
  --rdp-background-color: var(--ps-bg-hover) !important;
}

.dark-app .rdp-day {
  color: var(--ps-text-primary);
}

.dark-app .rdp-day_selected {
  background-color: var(--ps-primary) !important;
  color: var(--ps-bg-base) !important;
}

/* Modal/Dialog Dark Override */
.dark-app [role="dialog"] {
  background-color: var(--ps-bg-surface) !important;
  border: 1px solid var(--ps-border) !important;
}

/* Scrollbar Styling */
.dark-app ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.dark-app ::-webkit-scrollbar-track {
  background: var(--ps-bg-base);
}

.dark-app ::-webkit-scrollbar-thumb {
  background: var(--ps-border-light);
  border-radius: 4px;
}

.dark-app ::-webkit-scrollbar-thumb:hover {
  background: var(--ps-text-muted);
}

/* Safe area utilities for mobile */
.pb-safe {
  padding-bottom: env(safe-area-inset-bottom, 0px);
}

/* More menu with submenu support */
.more-menu-item.justify-between {
  justify-content: space-between;
}

/* Overscroll behavior for chat */
.overscroll-contain {
  overscroll-behavior: contain;
}



/* Online status glow effect for usernames */
.online-glow {
  text-shadow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4), 0 0 24px rgba(34, 197, 94, 0.2);
  animation: online-pulse 2s ease-in-out infinite;
}

@keyframes online-pulse {
  0%, 100% {
    text-shadow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4);
  }
  50% {
    text-shadow: 0 0 12px rgba(34, 197, 94, 0.8), 0 0 24px rgba(34, 197, 94, 0.5), 0 0 32px rgba(34, 197, 94, 0.3);
  }
}

/* Blue glow for users actively engaged in chat (sent message within last 3 minutes) */
.chatting-glow {
  text-shadow: 0 0 8px rgba(59, 130, 246, 0.7), 0 0 16px rgba(59, 130, 246, 0.5), 0 0 24px rgba(59, 130, 246, 0.3);
  animation: chatting-pulse 1.5s ease-in-out infinite;
}

@keyframes chatting-pulse {
  0%, 100% {
    text-shadow: 0 0 8px rgba(59, 130, 246, 0.7), 0 0 16px rgba(59, 130, 246, 0.5);
  }
  50% {
    text-shadow: 0 0 14px rgba(59, 130, 246, 0.9), 0 0 28px rgba(59, 130, 246, 0.6), 0 0 36px rgba(59, 130, 246, 0.4);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/dark-theme.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;;iDAEiD;AACjD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;iDAEiD;AACjD;;EAEE,gCAAgC;EAChC,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,0CAA0C;EAC1C,yCAAyC;;EAEzC,uBAAuB;EACvB,iFAAiF;;EAEjF,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;;EAEvB,6BAA6B;EAC7B,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;;EAEtB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;;EAE1B,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;;EAEzB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;;EAEhC,2BAA2B;EAC3B,yFAAyF;EACzF,kDAAkD;EAClD,4CAA4C;AAC9C;;AAEA;;;;;;iDAMiD;AACjD;EACE,+DAA+D;EAC/D,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,2CAA2C;EAC3C,0CAA0C;;EAE1C,6DAA6D;EAC7D,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;;EAEvB,sCAAsC;EACtC,qBAAqB,YAAY,qCAAqC;EACtE,wBAAwB,UAAU,qBAAqB;EACvD,yBAAyB,SAAS,+BAA+B;EACjE,sBAAsB,YAAY,gBAAgB;;EAElD,kBAAkB;EAClB,oBAAoB,cAAc,iBAAiB;EACnD,0BAA0B,QAAQ,qBAAqB;;EAEvD,gBAAgB;EAChB,0BAA0B,QAAQ,eAAe;EACjD,4BAA4B,MAAM,gBAAgB;EAClD,wBAAwB,UAAU,eAAe;EACjD,yBAAyB,SAAS,iBAAiB;;EAEnD,qDAAqD;EACrD,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;;EAElB,kBAAkB;EAClB,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;iDAEiD;;AAEjD,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,WAAW;AACX;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA,oCAAoC;AACpC;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB,kBAAkB,+BAA+B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,8BAA8B,EAAE;;AAElD,iBAAiB,+BAA+B,EAAE;AAClD,iBAAiB,6BAA6B,EAAE;AAChD,iBAAiB,8BAA8B,EAAE;;AAEjD,yBAAyB;AACzB,oCAAoC,gCAAgC,EAAE;AACtE,mCAAmC,gCAAgC,EAAE;;AAErE,+BAA+B,gCAAgC,EAAE;AACjE,8BAA8B,gCAAgC,EAAE;;AAEhE,qBAAqB;AACrB;;;EAGE,2BAA2B;AAC7B;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB,sBAAsB,+BAA+B,EAAE;AACvD,qBAAqB,+BAA+B,EAAE;;AAEtD,uBAAuB;AACvB;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;;;;EAIE,kBAAkB;AACpB;;AAEA;;iDAEiD;;AAEjD,qCAAqC;AACrC;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,iCAAiC;AACjC;;EAEE,wEAAwE;AAC1E;;AAEA;;EAEE,uEAAuE;AACzE;;AAEA,6CAA6C;AAC7C;EACE,8CAA8C;EAC9C,YAAY;AACd;;AAEA,kCAAkC;AAClC;;;EAGE,sCAAsC;EACtC,6BAA6B;AAC/B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,uCAAuC;AACzC;;AAEA,iCAAiC;AACjC;EACE,sCAAsC;AACxC;;AAEA,4BAA4B;AAC5B;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,sCAAsC;AACtC;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,yCAAyC;AACzC;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iCAAiC;AACjC;;EAEE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;EACE,8DAA8D;AAChE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,sCAAsC;AACxC;;AAEA,+BAA+B;AAC/B;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,uCAAuC;AACzC;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;;;;;;EAME,uBAAuB;AACzB;;AAEA;;iDAEiD;;AAEjD;;;iDAGiD;;AAEjD,gEAAgE;AAChE;;;;;EAKE;;;;0BAIwB;EACxB,2CAA2C;EAC3C,oCAAoC;EACpC,mBAAmB;EACnB;;;;qCAImC;EACnC,yBAAyB;AAC3B;;AAEA;;;;;EAKE,aAAa;EACb,+BAA+B;EAC/B;;;;;qCAKmC;AACrC;;AAEA,2CAA2C;AAC3C;;;EAGE;;;yBAGuB;EACvB,kCAAkC;EAClC,2CAA2C;EAC3C;;;2CAGyC;EACzC,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;;EAEE;;;;0BAIwB;EACxB,2CAA2C;EAC3C,oCAAoC;EACpC,8CAA8C;EAC9C,mBAAmB;EACnB;;;;qCAImC;AACrC;;AAEA,0CAA0C;AAC1C;;;;;EAKE;;;;yBAIuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC;;;;oCAIkC;AACpC;;AAEA;;;EAGE,+BAA+B;EAC/B;;;;;oCAKkC;AACpC;;AAEA;;;EAGE;;;yBAGuB;EACvB,0CAA0C;EAC1C;;;0CAGwC;AAC1C;;AAEA;;EAEE;;;;0BAIwB;EACxB,kCAAkC;EAClC,oCAAoC;EACpC;;;;oCAIkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,mCAAmC;EACnC,6BAA6B;EAC7B,iBAAiB;EACjB,mEAAmE;AACrE;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mDAAmD;AACrD;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,2CAA2C;EAC3C,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,qDAAqD;EACrD,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;;;2CAIyC;EACzC,6CAA6C;EAC7C,qDAAqD;AACvD;;AAEA;EACE;IACE;;;;6CAIyC;EAC3C;EACA;IACE;;;;6CAIyC;EAC3C;AACF;;AAEA;EACE,qBAAqB;EACrB;;;;2CAIyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,iDAAiD;EACjD,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,sCAAsC;EACtC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,uDAAuD;EACvD,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,oCAAoC;EACpC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,cAAc;EACd,wDAAwD,EAAE,2BAA2B;AACvF;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,SAAS;EACT,cAAc;EACd,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kDAAkD;EAClD,6CAA6C;EAC7C,wCAAwC;EACxC,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA,uBAAuB;AACvB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,2DAA2D;AAC7D;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;EAClC,8DAA8D;AAChE;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mCAAmC;EACnC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,sCAAsC;IACtC,wCAAwC;IACxC,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA,2CAA2C;;AAE3C,mBAAmB;AACnB;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,yCAAyC;EACzC,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yCAAyC;EACzC,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA,kBAAkB;AAClB;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,sCAAsC;EACtC,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,sCAAsC;EACtC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,iDAAiD;EACjD,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;EACjD,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;EACtB,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,wFAAwF;EACxF,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,uCAAuC;EACvC,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,iDAAiD;EACjD,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA,2BAA2B;AAC3B;EACE,gDAAgD;EAChD,qDAAqD;AACvD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA,+BAA+B;AAC/B;EACE,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mCAAmC;AACnC;EACE,gDAAgD;AAClD;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,4BAA4B;AAC9B;;;;AAIA,4CAA4C;AAC5C;EACE,6GAA6G;EAC7G,+CAA+C;AACjD;;AAEA;EACE;IACE,4EAA4E;EAC9E;EACA;IACE,8GAA8G;EAChH;AACF;;AAEA,sFAAsF;AACtF;EACE,gHAAgH;EAChH,mDAAmD;AACrD;;AAEA;EACE;IACE,8EAA8E;EAChF;EACA;IACE,iHAAiH;EACnH;AACF","sourcesContent":["/* Par Seeker Theme System */\n\n/* ============================================\n   GLOBAL OVERFLOW FIX - Prevent horizontal scroll\n   ============================================ */\nhtml, body {\n  overflow-x: hidden;\n  max-width: 100vw;\n  width: 100%;\n}\n\n#root {\n  overflow-x: hidden;\n  max-width: 100vw;\n  width: 100%;\n}\n\n/* ============================================\n   DEFAULT (Dark Theme) - Applied by default\n   ============================================ */\n:root,\n.theme-dark {\n  /* Primary Colors - Golf Green */\n  --ps-primary: #22c55e;\n  --ps-primary-hover: #16a34a;\n  --ps-primary-dark: #15803d;\n  --ps-primary-light: rgba(34, 197, 94, 0.1);\n  --ps-primary-glow: rgba(34, 197, 94, 0.3);\n  \n  /* Online Status Glow */\n  --ps-online-glow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4);\n  \n  /* Accent Colors - Logo Gold */\n  --ps-gold: #D4A017;\n  --ps-gold-light: #F5C542;\n  --ps-gold-dark: #B8860B;\n  \n  /* Background Colors - Dark */\n  --ps-bg-base: #0A0A0A;\n  --ps-bg-surface: #171717;\n  --ps-bg-elevated: #1f1f1f;\n  --ps-bg-hover: #262626;\n  \n  /* Border Colors */\n  --ps-border: #262626;\n  --ps-border-light: #333333;\n  \n  /* Text Colors */\n  --ps-text-primary: #FFFFFF;\n  --ps-text-secondary: #A3A3A3;\n  --ps-text-muted: #737373;\n  --ps-text-accent: #22c55e;\n  \n  /* Semantic Colors */\n  --ps-success: #22c55e;\n  --ps-warning: #f59e0b;\n  --ps-error: #ef4444;\n  --ps-info: #3b82f6;\n  \n  /* Glass/Overlay */\n  --ps-glass-bg: rgba(10, 10, 10, 0.85);\n  --ps-overlay: rgba(0, 0, 0, 0.6);\n  \n  /* 3D Inset Shadow Effect */\n  --ps-inset-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.4), inset 0 1px 2px rgba(0, 0, 0, 0.3);\n  --ps-inset-glow: 0 1px 0 rgba(255, 255, 255, 0.05);\n  --ps-field-border: rgba(255, 255, 255, 0.08);\n}\n\n/* ============================================\n   LIGHT THEME - Golf Course Inspired\n   Based on natural golf course colors:\n   - Fresh green fairways\n   - Cream/tan bunker sand  \n   - Bright sky blues\n   ============================================ */\n.theme-light {\n  /* Primary Colors - Golf Green (slightly darker for contrast) */\n  --ps-primary: #16a34a;\n  --ps-primary-hover: #15803d;\n  --ps-primary-dark: #166534;\n  --ps-primary-light: rgba(22, 163, 74, 0.12);\n  --ps-primary-glow: rgba(22, 163, 74, 0.25);\n  \n  /* Accent Colors - Logo Gold (darker for light bg contrast) */\n  --ps-gold: #B8860B;\n  --ps-gold-light: #D4A017;\n  --ps-gold-dark: #8B6914;\n  \n  /* Background Colors - Light/Natural */\n  --ps-bg-base: #F5F5F0;           /* Warm off-white like fairway mist */\n  --ps-bg-surface: #FFFFFF;         /* Pure white cards */\n  --ps-bg-elevated: #FAFAF5;        /* Slightly elevated surfaces */\n  --ps-bg-hover: #EEEEEA;           /* Hover state */\n  \n  /* Border Colors */\n  --ps-border: #E5E5E0;             /* Soft borders */\n  --ps-border-light: #D4D4D0;       /* Stronger borders */\n  \n  /* Text Colors */\n  --ps-text-primary: #1A1A1A;       /* Near black */\n  --ps-text-secondary: #525252;     /* Medium gray */\n  --ps-text-muted: #737373;         /* Light gray */\n  --ps-text-accent: #16a34a;        /* Green accent */\n  \n  /* Semantic Colors (slightly adjusted for light bg) */\n  --ps-success: #16a34a;\n  --ps-warning: #d97706;\n  --ps-error: #dc2626;\n  --ps-info: #2563eb;\n  \n  /* Glass/Overlay */\n  --ps-glass-bg: rgba(255, 255, 255, 0.9);\n  --ps-overlay: rgba(0, 0, 0, 0.4);\n}\n\n/* ============================================\n   FONT SIZE SCALING\n   ============================================ */\n\n/* Small (Default/Current) */\n.font-small {\n  --ps-font-scale: 1;\n  --ps-spacing-scale: 1;\n}\n\n/* Medium */\n.font-medium {\n  --ps-font-scale: 1.1;\n  --ps-spacing-scale: 1.05;\n}\n\n/* Large */\n.font-large {\n  --ps-font-scale: 1.2;\n  --ps-spacing-scale: 1.1;\n}\n\n/* Apply font scaling to body text */\n.font-medium body,\n.font-medium .dark-app {\n  font-size: calc(1rem * 1.1);\n}\n\n.font-large body,\n.font-large .dark-app {\n  font-size: calc(1rem * 1.2);\n}\n\n/* Scale headings */\n.font-medium h1 { font-size: calc(1.875rem * 1.1); }\n.font-medium h2 { font-size: calc(1.5rem * 1.1); }\n.font-medium h3 { font-size: calc(1.25rem * 1.1); }\n\n.font-large h1 { font-size: calc(1.875rem * 1.2); }\n.font-large h2 { font-size: calc(1.5rem * 1.2); }\n.font-large h3 { font-size: calc(1.25rem * 1.2); }\n\n/* Scale feed post text */\n.font-medium .feed-post-content p { font-size: calc(0.9375rem * 1.1); }\n.font-large .feed-post-content p { font-size: calc(0.9375rem * 1.2); }\n\n.font-medium .feed-post-name { font-size: calc(0.9375rem * 1.1); }\n.font-large .feed-post-name { font-size: calc(0.9375rem * 1.2); }\n\n/* Scale input text */\n.font-medium input,\n.font-medium textarea,\n.font-medium select {\n  font-size: calc(1rem * 1.1);\n}\n\n.font-large input,\n.font-large textarea,\n.font-large select {\n  font-size: calc(1rem * 1.2);\n}\n\n/* Scale button text */\n.font-medium button { font-size: calc(0.875rem * 1.1); }\n.font-large button { font-size: calc(0.875rem * 1.2); }\n\n/* Scale card content */\n.font-medium .dark-card p,\n.font-medium .dark-card span:not(.text-xs) {\n  font-size: calc(0.875rem * 1.1);\n}\n\n.font-large .dark-card p,\n.font-large .dark-card span:not(.text-xs) {\n  font-size: calc(0.875rem * 1.2);\n}\n\n/* Keep navigation labels small */\n.font-medium .bottom-nav-item,\n.font-large .bottom-nav-item,\n.font-medium .top-nav-item,\n.font-large .top-nav-item {\n  font-size: 0.65rem;\n}\n\n/* ============================================\n   LIGHT THEME SPECIFIC OVERRIDES\n   ============================================ */\n\n/* Glass navigation for light theme */\n.theme-light .glass-nav {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n/* Card shadows for light theme */\n.theme-light .dark-card,\n.theme-light .feed-post {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.theme-light .dark-card:hover,\n.theme-light .feed-post:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);\n}\n\n/* Create button adjustment for light theme */\n.theme-light .create-btn {\n  box-shadow: 0 4px 14px rgba(22, 163, 74, 0.35);\n  color: white;\n}\n\n/* Input styling for light theme */\n.theme-light input,\n.theme-light textarea,\n.theme-light select {\n  background-color: var(--ps-bg-surface);\n  color: var(--ps-text-primary);\n}\n\n.theme-light input::placeholder,\n.theme-light textarea::placeholder {\n  color: var(--ps-text-muted);\n}\n\n/* Avatar fallback for light theme */\n.theme-light .bg-\\[var\\(--ps-bg-elevated\\)\\] {\n  background-color: var(--ps-bg-elevated);\n}\n\n/* Dialog/Modal for light theme */\n.theme-light [role=\"dialog\"] {\n  background-color: var(--ps-bg-surface);\n}\n\n/* Spinner for light theme */\n.theme-light .dark-spinner {\n  border-color: var(--ps-border);\n  border-top-color: var(--ps-primary);\n}\n\n/* Bottom navigation for light theme */\n.theme-light .bottom-nav {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n/* Top navigation icons for light theme */\n.theme-light .top-nav-item {\n  color: var(--ps-text-secondary);\n}\n\n.theme-light .top-nav-item.active {\n  color: var(--ps-primary);\n}\n\n.theme-light .top-nav-item:hover {\n  color: var(--ps-text-primary);\n}\n\n/* Glass header for light theme */\n.theme-light .glass-nav,\n.theme-light .dark-header {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n}\n\n/* Feed tabs for light theme */\n.theme-light .feed-tab {\n  color: var(--ps-text-secondary);\n}\n\n.theme-light .feed-tab.active {\n  color: var(--ps-primary);\n}\n\n/* Story avatar wrapper for light theme */\n.theme-light .story-avatar-wrapper {\n  background: linear-gradient(45deg, var(--ps-primary), #059669);\n}\n\n.theme-light .story-avatar-wrapper.no-story {\n  background: var(--ps-border);\n}\n\n/* Stats widget for light theme */\n.theme-light .compact-stats-widget {\n  background-color: var(--ps-bg-surface);\n}\n\n/* Post header options button */\n.theme-light .feed-post-header button {\n  color: var(--ps-text-secondary);\n}\n\n.theme-light .feed-post-header button:hover {\n  color: var(--ps-text-primary);\n}\n\n/* Buttons with bg-elevated */\n.theme-light .bg-\\[var\\(--ps-bg-elevated\\)\\] {\n  background-color: var(--ps-bg-elevated);\n}\n\n/* Fix white text that should be dark in light mode */\n.theme-light .text-white {\n  color: var(--ps-text-primary);\n}\n\n/* But keep white text on colored backgrounds */\n.theme-light .bg-\\[var\\(--ps-primary\\)\\] .text-white,\n.theme-light .bg-gradient-to-br .text-white,\n.theme-light .create-btn,\n.theme-light [class*=\"bg-green\"] .text-white,\n.theme-light [class*=\"bg-blue\"] .text-white,\n.theme-light [class*=\"bg-red\"] .text-white {\n  color: white !important;\n}\n\n/* ============================================\n   DARK THEME (Existing Styles Below)\n   ============================================ */\n\n/* ============================================\n   3D INSET SHADOW - Input Fields & Borders\n   Creates depth effect on all interactive fields\n   ============================================ */\n\n/* Global input, textarea, select styling with 3D inset effect */\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\ntextarea,\nselect,\n.ps-input,\n.ps-field {\n  background: linear-gradient(180deg, \n    rgba(0, 0, 0, 0.15) 0%, \n    rgba(20, 20, 20, 0.05) 15%,\n    rgba(30, 30, 30, 0) 100%\n  ), var(--ps-bg-elevated);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-top-color: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  box-shadow: \n    inset 0 3px 8px rgba(0, 0, 0, 0.5),\n    inset 0 1px 3px rgba(0, 0, 0, 0.4),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.05),\n    0 1px 0 rgba(255, 255, 255, 0.03);\n  transition: all 0.2s ease;\n}\n\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):focus,\ntextarea:focus,\nselect:focus,\n.ps-input:focus,\n.ps-field:focus {\n  outline: none;\n  border-color: var(--ps-primary);\n  box-shadow: \n    inset 0 3px 8px rgba(0, 0, 0, 0.5),\n    inset 0 1px 3px rgba(0, 0, 0, 0.4),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.05),\n    0 0 0 3px rgba(34, 197, 94, 0.2),\n    0 1px 0 rgba(255, 255, 255, 0.03);\n}\n\n/* Cards and containers with subtle depth */\n.ps-card,\n.dark-card,\n.dark-stat-card {\n  background: linear-gradient(180deg,\n    rgba(255, 255, 255, 0.03) 0%,\n    rgba(255, 255, 255, 0) 100%\n  ), var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-top-color: rgba(255, 255, 255, 0.08);\n  box-shadow: \n    0 4px 12px rgba(0, 0, 0, 0.4),\n    0 2px 4px rgba(0, 0, 0, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n}\n\n/* Inset containers (like the message box in the screenshot) */\n.ps-inset,\n.inset-field {\n  background: linear-gradient(180deg,\n    rgba(0, 0, 0, 0.2) 0%,\n    rgba(0, 0, 0, 0.05) 20%,\n    rgba(30, 30, 30, 0) 100%\n  ), var(--ps-bg-elevated);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  border-top-color: rgba(0, 0, 0, 0.4);\n  border-bottom-color: rgba(255, 255, 255, 0.06);\n  border-radius: 12px;\n  box-shadow: \n    inset 0 4px 10px rgba(0, 0, 0, 0.5),\n    inset 0 2px 4px rgba(0, 0, 0, 0.4),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.04),\n    0 1px 0 rgba(255, 255, 255, 0.02);\n}\n\n/* Light theme adjustments for 3D effect */\n.theme-light input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]),\n.theme-light textarea,\n.theme-light select,\n.theme-light .ps-input,\n.theme-light .ps-field {\n  background: linear-gradient(180deg,\n    rgba(0, 0, 0, 0.04) 0%,\n    rgba(0, 0, 0, 0.01) 15%,\n    rgba(255, 255, 255, 0) 100%\n  ), var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-top-color: rgba(0, 0, 0, 0.12);\n  box-shadow: \n    inset 0 2px 6px rgba(0, 0, 0, 0.08),\n    inset 0 1px 3px rgba(0, 0, 0, 0.06),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.9),\n    0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.theme-light input:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"range\"]):focus,\n.theme-light textarea:focus,\n.theme-light select:focus {\n  border-color: var(--ps-primary);\n  box-shadow: \n    inset 0 2px 6px rgba(0, 0, 0, 0.08),\n    inset 0 1px 3px rgba(0, 0, 0, 0.06),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.9),\n    0 0 0 3px rgba(22, 163, 74, 0.15),\n    0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.theme-light .ps-card,\n.theme-light .dark-card,\n.theme-light .dark-stat-card {\n  background: linear-gradient(180deg,\n    rgba(255, 255, 255, 0.8) 0%,\n    rgba(255, 255, 255, 0) 100%\n  ), var(--ps-bg-surface);\n  border-top-color: rgba(255, 255, 255, 0.9);\n  box-shadow: \n    0 2px 8px rgba(0, 0, 0, 0.08),\n    0 1px 3px rgba(0, 0, 0, 0.05),\n    inset 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.theme-light .ps-inset,\n.theme-light .inset-field {\n  background: linear-gradient(180deg,\n    rgba(0, 0, 0, 0.05) 0%,\n    rgba(0, 0, 0, 0.02) 20%,\n    rgba(255, 255, 255, 0) 100%\n  ), var(--ps-bg-elevated);\n  border: 1px solid var(--ps-border);\n  border-top-color: rgba(0, 0, 0, 0.1);\n  box-shadow: \n    inset 0 3px 8px rgba(0, 0, 0, 0.1),\n    inset 0 1px 4px rgba(0, 0, 0, 0.08),\n    inset 0 -1px 0 rgba(255, 255, 255, 0.9),\n    0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n/* Dark Theme App Container */\n.dark-app {\n  background-color: var(--ps-bg-base);\n  color: var(--ps-text-primary);\n  min-height: 100vh;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Glassmorphism Navigation */\n.glass-nav {\n  background: rgba(10, 10, 10, 0.85);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-color: var(--ps-border);\n}\n\n/* Top Navigation */\n.top-nav {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--ps-border);\n}\n\n.top-nav-inner {\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.top-nav-icons {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.top-nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 0.75rem;\n  border-radius: 0.75rem;\n  color: var(--ps-text-secondary);\n  font-size: 0.65rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  cursor: pointer;\n}\n\n.top-nav-item:hover {\n  color: var(--ps-text-primary);\n  background-color: var(--ps-bg-hover);\n}\n\n.top-nav-item.active {\n  color: var(--ps-primary);\n}\n\n.top-nav-item.active svg {\n  filter: drop-shadow(0 0 8px var(--ps-primary-glow));\n}\n\n/* Bottom Navigation */\n.bottom-nav {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 50;\n  padding: 0;\n  padding-bottom: env(safe-area-inset-bottom);\n  border-top: none;\n  background-color: var(--ps-bg-surface);\n}\n\n/* Ticker wrapper inside bottom nav */\n.ticker-wrapper {\n  width: 100%;\n  border-top: 1px solid var(--ps-border);\n}\n\n.bottom-nav-inner {\n  max-width: 640px;\n  margin: 0 auto;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  padding: 0.5rem 1rem;\n}\n\n.bottom-nav-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.5rem 1rem;\n  border-radius: 0.75rem;\n  color: var(--ps-text-secondary);\n  font-size: 0.65rem;\n  font-weight: 500;\n  transition: color 0.2s ease, transform 0.2s ease;\n  cursor: pointer;\n}\n\n.bottom-nav-item:hover {\n  color: var(--ps-text-primary);\n}\n\n.bottom-nav-item.active {\n  color: var(--ps-primary);\n}\n\n.bottom-nav-item:active {\n  transform: scale(0.95);\n}\n\n/* Center Create Button */\n.create-btn {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: var(--ps-primary);\n  color: var(--ps-bg-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -1.5rem;\n  box-shadow: 0 4px 20px var(--ps-primary-glow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  cursor: pointer;\n}\n\n.create-btn:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 25px var(--ps-primary-glow);\n}\n\n.create-btn:active {\n  transform: scale(0.95);\n}\n\n/* Quick Post Button - Glowing Blue Plus in Bottom Nav */\n.quick-post-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.25rem;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.quick-post-btn-inner {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #00bfff 0%, #0080ff 50%, #00bfff 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: \n    0 0 15px rgba(0, 191, 255, 0.6),\n    0 0 30px rgba(0, 191, 255, 0.4),\n    0 0 45px rgba(0, 191, 255, 0.2),\n    inset 0 0 10px rgba(255, 255, 255, 0.3);\n  animation: pulse-glow 2s ease-in-out infinite;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n@keyframes pulse-glow {\n  0%, 100% {\n    box-shadow: \n      0 0 15px rgba(0, 191, 255, 0.6),\n      0 0 30px rgba(0, 191, 255, 0.4),\n      0 0 45px rgba(0, 191, 255, 0.2),\n      inset 0 0 10px rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    box-shadow: \n      0 0 20px rgba(0, 191, 255, 0.8),\n      0 0 40px rgba(0, 191, 255, 0.5),\n      0 0 60px rgba(0, 191, 255, 0.3),\n      inset 0 0 15px rgba(255, 255, 255, 0.4);\n  }\n}\n\n.quick-post-btn:hover .quick-post-btn-inner {\n  transform: scale(1.1);\n  box-shadow: \n    0 0 25px rgba(0, 191, 255, 0.8),\n    0 0 50px rgba(0, 191, 255, 0.5),\n    0 0 75px rgba(0, 191, 255, 0.3),\n    inset 0 0 15px rgba(255, 255, 255, 0.4);\n}\n\n.quick-post-btn:active .quick-post-btn-inner {\n  transform: scale(0.95);\n}\n\n/* Dark Theme Cards */\n.dark-card {\n  background-color: var(--ps-bg-surface) !important;\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n}\n\n.dark-card:hover {\n  border-color: var(--ps-border-light);\n}\n\n/* Feed Post Card */\n.feed-post {\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  overflow: hidden;\n  transition: border-color 0.2s ease;\n}\n\n.feed-post:hover {\n  border-color: var(--ps-border-light);\n}\n\n.feed-post-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 1rem;\n}\n\n.feed-post-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.feed-post-avatar {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid var(--ps-border);\n}\n\n.feed-post-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.125rem;\n}\n\n.feed-post-name {\n  font-weight: 600;\n  color: var(--ps-text-primary);\n  font-size: 0.9375rem;\n}\n\n.feed-post-details {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--ps-text-muted);\n}\n\n.handicap-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.125rem 0.5rem;\n  border-radius: 9999px;\n  background-color: var(--ps-primary-light);\n  color: var(--ps-primary);\n  font-size: 0.6875rem;\n  font-weight: 600;\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.category-badge {\n  color: var(--ps-primary);\n  font-weight: 500;\n}\n\n.feed-post-content {\n  padding: 0 1rem 1rem;\n  color: var(--ps-text-primary);\n  font-size: 0.9375rem;\n  line-height: 1.5;\n}\n\n.feed-post-image {\n  width: 100%;\n  max-height: 500px;\n  object-fit: cover;\n}\n\n.feed-post-reactions {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.75rem 1rem;\n  border-top: 1px solid var(--ps-border);\n  font-size: 0.8125rem;\n  color: var(--ps-text-secondary);\n}\n\n.reaction-avatars {\n  display: flex;\n  align-items: center;\n}\n\n.reaction-avatars img {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 2px solid var(--ps-bg-surface);\n  margin-left: -8px;\n}\n\n.reaction-avatars img:first-child {\n  margin-left: 0;\n}\n\n.feed-post-actions {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0.5rem 1rem;\n  border-top: 1px solid var(--ps-border);\n}\n\n.post-action-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n  color: var(--ps-text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: color 0.2s ease, background-color 0.2s ease;\n  cursor: pointer;\n}\n\n.post-action-btn:hover {\n  color: var(--ps-text-primary);\n  background-color: var(--ps-bg-hover);\n}\n\n.post-action-btn.liked {\n  color: var(--ps-error);\n}\n\n.post-action-btn.liked svg {\n  fill: currentColor;\n}\n\n/* Stories Row */\n.stories-container {\n  display: flex;\n  gap: 1rem;\n  padding: 1rem;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.stories-container::-webkit-scrollbar {\n  display: none;\n}\n\n.story-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.story-avatar-wrapper {\n  position: relative;\n  padding: 3px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--ps-primary) 0%, #10b981 100%);\n}\n\n.story-avatar-wrapper.no-story {\n  background: var(--ps-border);\n}\n\n.story-avatar-wrapper.create {\n  background: var(--ps-bg-surface);\n  border: 2px dashed var(--ps-border);\n}\n\n.story-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  object-fit: cover;\n  background-color: var(--ps-bg-surface);\n  border: 3px solid var(--ps-bg-base);\n}\n\n.story-create-icon {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: var(--ps-primary);\n  color: var(--ps-bg-base);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--ps-bg-base);\n}\n\n.story-name {\n  font-size: 0.6875rem;\n  color: var(--ps-text-secondary);\n  max-width: 70px;\n  text-align: center;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Feed Filter Tabs */\n.feed-tabs {\n  display: flex;\n  gap: 1.5rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid var(--ps-border);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.feed-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.feed-tab {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--ps-text-secondary);\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid transparent;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n\n.feed-tab:hover {\n  color: var(--ps-text-primary);\n}\n\n.feed-tab.active {\n  color: var(--ps-text-primary);\n  border-bottom-color: var(--ps-primary);\n}\n\n/* Main Content Area */\n.dark-main-content {\n  max-width: 640px;\n  margin: 0 auto;\n  padding-bottom: calc(7rem + env(safe-area-inset-bottom)); /* Space for ticker + nav */\n}\n\n/* Full Screen Main Content - No navigation padding */\n.dark-main-content-fullscreen {\n  max-width: 100%;\n  margin: 0;\n  padding-top: 0;\n  padding-bottom: env(safe-area-inset-bottom);\n  min-height: 100vh;\n  min-height: 100dvh;\n}\n\n/* Dark Theme Inputs */\n.dark-input {\n  background-color: var(--ps-bg-elevated) !important;\n  border: 1px solid var(--ps-border) !important;\n  color: var(--ps-text-primary) !important;\n  border-radius: 0.75rem;\n  padding: 0.75rem 1rem;\n  font-size: 0.9375rem;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.dark-input:focus {\n  outline: none;\n  border-color: var(--ps-primary) !important;\n  box-shadow: 0 0 0 3px var(--ps-primary-light);\n}\n\n.dark-input::placeholder {\n  color: var(--ps-text-muted) !important;\n}\n\n/* Dark Theme Buttons */\n.dark-btn-primary {\n  background-color: var(--ps-primary);\n  color: var(--ps-bg-base);\n  font-weight: 600;\n  padding: 0.75rem 1.5rem;\n  border-radius: 9999px;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.dark-btn-primary:hover {\n  background-color: var(--ps-primary-hover);\n}\n\n.dark-btn-primary:active {\n  transform: scale(0.98);\n}\n\n.dark-btn-secondary {\n  background-color: var(--ps-bg-hover);\n  color: var(--ps-text-primary);\n  font-weight: 500;\n  padding: 0.75rem 1.5rem;\n  border-radius: 9999px;\n  border: 1px solid var(--ps-border);\n  transition: background-color 0.2s ease, border-color 0.2s ease;\n}\n\n.dark-btn-secondary:hover {\n  background-color: var(--ps-bg-elevated);\n  border-color: var(--ps-border-light);\n}\n\n/* Notification Badge */\n.notification-badge {\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  min-width: 18px;\n  height: 18px;\n  border-radius: 9999px;\n  background-color: var(--ps-error);\n  color: white;\n  font-size: 0.625rem;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n}\n\n/* Loading Spinner (Dark) */\n.dark-spinner {\n  width: 2rem;\n  height: 2rem;\n  border: 3px solid var(--ps-border);\n  border-top-color: var(--ps-primary);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* Empty State */\n.dark-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: var(--ps-text-secondary);\n}\n\n.dark-empty-state svg {\n  width: 4rem;\n  height: 4rem;\n  margin-bottom: 1.5rem;\n  color: var(--ps-text-muted);\n}\n\n/* Story Viewer Modal */\n.story-viewer {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background-color: var(--ps-bg-base);\n  display: flex;\n  flex-direction: column;\n}\n\n.story-viewer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n}\n\n.story-progress-container {\n  display: flex;\n  gap: 4px;\n  padding: 0.5rem 1rem;\n}\n\n.story-progress-bar {\n  flex: 1;\n  height: 3px;\n  background-color: var(--ps-border);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.story-progress-fill {\n  height: 100%;\n  background-color: var(--ps-text-primary);\n  transition: width 0.1s linear;\n}\n\n.story-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n}\n\n.story-content img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 0.5rem;\n}\n\n/* Responsive Desktop Layout */\n@media (min-width: 768px) {\n  .dark-main-content {\n    padding-top: 1rem;\n  }\n  \n  .top-nav {\n    position: sticky;\n  }\n  \n  .bottom-nav {\n    display: none;\n  }\n  \n  /* Show desktop sidebar instead */\n  .dark-app.with-sidebar {\n    display: grid;\n    grid-template-columns: 280px 1fr;\n  }\n  \n  .dark-sidebar {\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 280px;\n    background-color: var(--ps-bg-surface);\n    border-right: 1px solid var(--ps-border);\n    padding: 1.5rem;\n    z-index: 40;\n  }\n  \n  .dark-main-with-sidebar {\n    margin-left: 280px;\n  }\n}\n\n/* Animation keyframes */\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.3s ease forwards;\n}\n\n/* More Menu Dropdown */\n.more-menu {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  margin-top: 0.5rem;\n  min-width: 200px;\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);\n  z-index: 100;\n}\n\n.more-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.875rem 1rem;\n  color: var(--ps-text-primary);\n  font-size: 0.875rem;\n  font-weight: 500;\n  transition: background-color 0.15s ease;\n  cursor: pointer;\n}\n\n.more-menu-item:hover {\n  background-color: var(--ps-bg-hover);\n}\n\n.more-menu-item svg {\n  width: 1.125rem;\n  height: 1.125rem;\n  color: var(--ps-text-secondary);\n}\n\n.more-menu-divider {\n  height: 1px;\n  background-color: var(--ps-border);\n  margin: 0.25rem 0;\n}\n\n/* ========== DARK PAGE STYLES ========== */\n\n/* Page Container */\n.dark-page {\n  min-height: 100%;\n  padding-bottom: 5rem;\n}\n\n/* Page Header */\n.dark-page-header {\n  padding: 1rem;\n  border-bottom: 1px solid var(--ps-border);\n}\n\n.dark-page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--ps-text-primary);\n}\n\n.dark-page-subtitle {\n  font-size: 0.875rem;\n  color: var(--ps-text-muted);\n  margin-top: 0.25rem;\n}\n\n/* Section Headers */\n.dark-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n}\n\n.dark-section-title {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--ps-text-primary);\n}\n\n/* Stats Cards */\n.dark-stats-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n\n@media (min-width: 640px) {\n  .dark-stats-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.dark-stat-card {\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  padding: 1rem;\n  text-align: center;\n  transition: border-color 0.2s ease;\n}\n\n.dark-stat-card:hover {\n  border-color: var(--ps-border-light);\n}\n\n.dark-stat-icon {\n  width: 2.5rem;\n  height: 2.5rem;\n  margin: 0 auto 0.75rem;\n  padding: 0.5rem;\n  background-color: var(--ps-primary-light);\n  border-radius: 0.75rem;\n  color: var(--ps-primary);\n}\n\n.dark-stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--ps-text-primary);\n  line-height: 1.2;\n}\n\n.dark-stat-label {\n  font-size: 0.75rem;\n  color: var(--ps-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-top: 0.25rem;\n}\n\n.dark-stat-change {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  margin-top: 0.5rem;\n}\n\n.dark-stat-change.positive {\n  color: var(--ps-success);\n}\n\n.dark-stat-change.negative {\n  color: var(--ps-error);\n}\n\n/* List Items */\n.dark-list {\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  overflow: hidden;\n}\n\n.dark-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  border-bottom: 1px solid var(--ps-border);\n  transition: background-color 0.15s ease;\n  cursor: pointer;\n}\n\n.dark-list-item:last-child {\n  border-bottom: none;\n}\n\n.dark-list-item:hover {\n  background-color: var(--ps-bg-hover);\n}\n\n.dark-list-item-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.dark-list-item-title {\n  font-weight: 600;\n  color: var(--ps-text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.dark-list-item-subtitle {\n  font-size: 0.875rem;\n  color: var(--ps-text-muted);\n  margin-top: 0.125rem;\n}\n\n.dark-list-item-meta {\n  text-align: right;\n  color: var(--ps-text-secondary);\n  font-size: 0.875rem;\n}\n\n/* Quick Action Buttons */\n.dark-quick-actions {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem;\n}\n\n@media (min-width: 640px) {\n  .dark-quick-actions {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n.dark-action-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 1.25rem 1rem;\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  color: var(--ps-text-secondary);\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.dark-action-btn:hover {\n  border-color: var(--ps-primary);\n  color: var(--ps-primary);\n  background-color: var(--ps-primary-light);\n}\n\n.dark-action-btn svg {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n\n.dark-action-btn.primary {\n  background-color: var(--ps-primary);\n  border-color: var(--ps-primary);\n  color: var(--ps-bg-base);\n}\n\n.dark-action-btn.primary:hover {\n  background-color: var(--ps-primary-hover);\n  border-color: var(--ps-primary-hover);\n  color: var(--ps-bg-base);\n}\n\n/* Form Sections */\n.dark-form-section {\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.dark-form-section-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--ps-text-primary);\n  margin-bottom: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dark-form-section-title svg {\n  width: 1.125rem;\n  height: 1.125rem;\n  color: var(--ps-primary);\n}\n\n.dark-form-row {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.dark-form-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Toggle Switches */\n.dark-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 0.75rem;\n}\n\n.dark-toggle-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.dark-toggle-label svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--ps-primary);\n}\n\n.dark-toggle-text {\n  font-weight: 500;\n  color: var(--ps-text-primary);\n}\n\n.dark-toggle-desc {\n  font-size: 0.75rem;\n  color: var(--ps-text-muted);\n  margin-top: 0.125rem;\n}\n\n/* Badge/Tags */\n.dark-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.625rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.dark-badge.primary {\n  background-color: var(--ps-primary-light);\n  color: var(--ps-primary);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.dark-badge.success {\n  background-color: rgba(34, 197, 94, 0.1);\n  color: var(--ps-success);\n}\n\n.dark-badge.warning {\n  background-color: rgba(245, 158, 11, 0.1);\n  color: var(--ps-warning);\n}\n\n.dark-badge.error {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: var(--ps-error);\n}\n\n.dark-badge.info {\n  background-color: rgba(59, 130, 246, 0.1);\n  color: var(--ps-info);\n}\n\n.dark-badge.muted {\n  background-color: var(--ps-bg-hover);\n  color: var(--ps-text-muted);\n}\n\n/* Charts Container */\n.dark-chart-container {\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n  padding: 1rem;\n}\n\n/* Score Circle */\n.dark-score-circle {\n  width: 4rem;\n  height: 4rem;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--ps-bg-elevated);\n  border: 2px solid var(--ps-border);\n}\n\n.dark-score-circle.good {\n  border-color: var(--ps-success);\n  background-color: rgba(34, 197, 94, 0.1);\n}\n\n.dark-score-circle.bad {\n  border-color: var(--ps-error);\n  background-color: rgba(239, 68, 68, 0.1);\n}\n\n.dark-score-circle-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--ps-text-primary);\n  line-height: 1;\n}\n\n.dark-score-circle-label {\n  font-size: 0.625rem;\n  color: var(--ps-text-muted);\n  text-transform: uppercase;\n}\n\n/* Tabs */\n.dark-tabs {\n  display: flex;\n  gap: 0.5rem;\n  padding: 0.5rem;\n  background-color: var(--ps-bg-surface);\n  border-radius: 0.75rem;\n  border: 1px solid var(--ps-border);\n}\n\n.dark-tab {\n  flex: 1;\n  padding: 0.625rem 1rem;\n  border-radius: 0.5rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--ps-text-secondary);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dark-tab:hover {\n  color: var(--ps-text-primary);\n}\n\n.dark-tab.active {\n  background-color: var(--ps-primary);\n  color: var(--ps-bg-base);\n}\n\n/* Select Dropdown Dark Override */\n.dark-select [data-radix-select-trigger] {\n  background-color: var(--ps-bg-surface) !important;\n  border-color: var(--ps-border) !important;\n  color: var(--ps-text-primary) !important;\n}\n\n.dark-select [data-radix-select-content] {\n  background-color: var(--ps-bg-surface) !important;\n  border-color: var(--ps-border) !important;\n}\n\n.dark-select [data-radix-select-item] {\n  color: var(--ps-text-primary) !important;\n}\n\n.dark-select [data-radix-select-item]:hover,\n.dark-select [data-radix-select-item][data-highlighted] {\n  background-color: var(--ps-bg-hover) !important;\n}\n\n/* Table Styles */\n.dark-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.dark-table th {\n  text-align: left;\n  padding: 0.75rem 1rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--ps-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--ps-border);\n  background-color: var(--ps-bg-surface);\n}\n\n.dark-table td {\n  padding: 0.875rem 1rem;\n  font-size: 0.875rem;\n  color: var(--ps-text-primary);\n  border-bottom: 1px solid var(--ps-border);\n}\n\n.dark-table tr:hover td {\n  background-color: var(--ps-bg-hover);\n}\n\n.dark-table tr:last-child td {\n  border-bottom: none;\n}\n\n/* Scorecard Grid */\n.dark-scorecard {\n  display: grid;\n  grid-template-columns: repeat(9, 1fr);\n  gap: 2px;\n  background-color: var(--ps-border);\n  border-radius: 0.75rem;\n  overflow: hidden;\n}\n\n.dark-scorecard-cell {\n  background-color: var(--ps-bg-surface);\n  padding: 0.5rem;\n  text-align: center;\n  font-size: 0.875rem;\n}\n\n.dark-scorecard-cell.header {\n  background-color: var(--ps-bg-elevated);\n  font-weight: 600;\n  color: var(--ps-text-muted);\n  font-size: 0.75rem;\n}\n\n.dark-scorecard-cell.birdie {\n  color: var(--ps-success);\n  font-weight: 600;\n}\n\n.dark-scorecard-cell.bogey {\n  color: var(--ps-warning);\n}\n\n.dark-scorecard-cell.double {\n  color: var(--ps-error);\n}\n\n/* Handicap Display */\n.dark-handicap-display {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, var(--ps-bg-surface) 0%, var(--ps-bg-elevated) 100%);\n  border: 1px solid var(--ps-border);\n  border-radius: 1rem;\n}\n\n.dark-handicap-value {\n  font-size: 3rem;\n  font-weight: 800;\n  color: var(--ps-primary);\n  line-height: 1;\n}\n\n.dark-handicap-label {\n  font-size: 0.875rem;\n  color: var(--ps-text-muted);\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  margin-top: 0.5rem;\n}\n\n/* Divider */\n.dark-divider {\n  height: 1px;\n  background-color: var(--ps-border);\n  margin: 1.5rem 0;\n}\n\n/* Info Box */\n.dark-info-box {\n  display: flex;\n  gap: 0.75rem;\n  padding: 1rem;\n  background-color: var(--ps-bg-surface);\n  border: 1px solid var(--ps-border);\n  border-radius: 0.75rem;\n}\n\n.dark-info-box.info {\n  border-color: var(--ps-info);\n  background-color: rgba(59, 130, 246, 0.05);\n}\n\n.dark-info-box.warning {\n  border-color: var(--ps-warning);\n  background-color: rgba(245, 158, 11, 0.05);\n}\n\n.dark-info-box.success {\n  border-color: var(--ps-success);\n  background-color: rgba(34, 197, 94, 0.05);\n}\n\n.dark-info-box svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  flex-shrink: 0;\n}\n\n.dark-info-box.info svg {\n  color: var(--ps-info);\n}\n\n.dark-info-box.warning svg {\n  color: var(--ps-warning);\n}\n\n.dark-info-box.success svg {\n  color: var(--ps-success);\n}\n\n.dark-info-box-text {\n  font-size: 0.875rem;\n  color: var(--ps-text-secondary);\n}\n\n/* Avatar Styles */\n.dark-avatar {\n  width: 2.5rem;\n  height: 2.5rem;\n  border-radius: 50%;\n  background-color: var(--ps-bg-elevated);\n  border: 2px solid var(--ps-border);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ps-primary);\n  font-weight: 600;\n  overflow: hidden;\n}\n\n.dark-avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.dark-avatar.lg {\n  width: 4rem;\n  height: 4rem;\n  font-size: 1.5rem;\n}\n\n.dark-avatar.xl {\n  width: 6rem;\n  height: 6rem;\n  font-size: 2rem;\n}\n\n/* Dropdown/Popover Dark Override */\n[data-radix-popper-content-wrapper] {\n  z-index: 100 !important;\n}\n\n.dark-app [role=\"dialog\"],\n.dark-app [data-radix-select-content],\n.dark-app [data-radix-dropdown-menu-content],\n.dark-app [data-radix-popover-content] {\n  background-color: var(--ps-bg-surface) !important;\n  border-color: var(--ps-border) !important;\n  color: var(--ps-text-primary) !important;\n}\n\n/* Calendar Dark Override */\n.dark-app .rdp {\n  --rdp-accent-color: var(--ps-primary) !important;\n  --rdp-background-color: var(--ps-bg-hover) !important;\n}\n\n.dark-app .rdp-day {\n  color: var(--ps-text-primary);\n}\n\n.dark-app .rdp-day_selected {\n  background-color: var(--ps-primary) !important;\n  color: var(--ps-bg-base) !important;\n}\n\n/* Modal/Dialog Dark Override */\n.dark-app [role=\"dialog\"] {\n  background-color: var(--ps-bg-surface) !important;\n  border: 1px solid var(--ps-border) !important;\n}\n\n/* Scrollbar Styling */\n.dark-app ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.dark-app ::-webkit-scrollbar-track {\n  background: var(--ps-bg-base);\n}\n\n.dark-app ::-webkit-scrollbar-thumb {\n  background: var(--ps-border-light);\n  border-radius: 4px;\n}\n\n.dark-app ::-webkit-scrollbar-thumb:hover {\n  background: var(--ps-text-muted);\n}\n\n/* Safe area utilities for mobile */\n.pb-safe {\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n}\n\n/* More menu with submenu support */\n.more-menu-item.justify-between {\n  justify-content: space-between;\n}\n\n/* Overscroll behavior for chat */\n.overscroll-contain {\n  overscroll-behavior: contain;\n}\n\n\n\n/* Online status glow effect for usernames */\n.online-glow {\n  text-shadow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4), 0 0 24px rgba(34, 197, 94, 0.2);\n  animation: online-pulse 2s ease-in-out infinite;\n}\n\n@keyframes online-pulse {\n  0%, 100% {\n    text-shadow: 0 0 8px rgba(34, 197, 94, 0.6), 0 0 16px rgba(34, 197, 94, 0.4);\n  }\n  50% {\n    text-shadow: 0 0 12px rgba(34, 197, 94, 0.8), 0 0 24px rgba(34, 197, 94, 0.5), 0 0 32px rgba(34, 197, 94, 0.3);\n  }\n}\n\n/* Blue glow for users actively engaged in chat (sent message within last 3 minutes) */\n.chatting-glow {\n  text-shadow: 0 0 8px rgba(59, 130, 246, 0.7), 0 0 16px rgba(59, 130, 246, 0.5), 0 0 24px rgba(59, 130, 246, 0.3);\n  animation: chatting-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes chatting-pulse {\n  0%, 100% {\n    text-shadow: 0 0 8px rgba(59, 130, 246, 0.7), 0 0 16px rgba(59, 130, 246, 0.5);\n  }\n  50% {\n    text-shadow: 0 0 14px rgba(59, 130, 246, 0.9), 0 0 28px rgba(59, 130, 246, 0.6), 0 0 36px rgba(59, 130, 246, 0.4);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
